var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMilkomeda(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3049_23546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.884 22C16.9592 22 21.884 17.0751 21.884 11C21.884 4.92487 16.9592 0 10.884 0C4.8089 0 -0.115967 4.92487 -0.115967 11C-0.115967 17.0751 4.8089 22 10.884 22Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7236 9.3042L18.8846 11.3141L12.7691 14.8453C12.7691 14.8453 9.02379 17.1089 6.33105 12.4421L8.23532 11.3433C8.23532 11.3433 9.47272 14.0785 11.6175 12.8364C13.7622 11.5942 17.7236 9.3042 17.7236 9.3042Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.52847 12.4281L2.36743 10.4182L8.61306 6.81252C8.61306 6.81252 12.3584 4.54892 15.0502 9.2157L13.1459 10.3145C13.1459 10.3145 11.9085 7.57931 9.76373 8.82146C7.61899 10.0636 3.52847 12.4281 3.52847 12.4281Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7448 12.3792C11.5876 12.3792 12.2708 11.6959 12.2708 10.8531C12.2708 10.0103 11.5876 9.32709 10.7448 9.32709C9.90197 9.32709 9.21875 10.0103 9.21875 10.8531C9.21875 11.6959 9.90197 12.3792 10.7448 12.3792Z",
    fill: "#FF931E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.35459 14.7619C5.79475 14.7619 6.15157 14.4051 6.15157 13.965C6.15157 13.5248 5.79475 13.168 5.35459 13.168C4.91444 13.168 4.55762 13.5248 4.55762 13.965C4.55762 14.4051 4.91444 14.7619 5.35459 14.7619Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.994 8.61906C16.4341 8.61906 16.791 8.26225 16.791 7.82209C16.791 7.38194 16.4341 7.02512 15.994 7.02512C15.5538 7.02512 15.197 7.38194 15.197 7.82209C15.197 8.26225 15.5538 8.61906 15.994 8.61906Z",
    fill: "#F4F4F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3049_23546"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilkomeda);
export default __webpack_public_path__ + "static/media/milkomeda.8b784fd670b819373c01358f91e1da06.svg";
export { ForwardRef as ReactComponent };